import React, {useEffect, useState} from "react";
import {Container, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Link, Navigate, useNavigate, useLocation} from "react-router-dom";
import Select from "react-select";
import Header from "../header";
import ApiService from "../util/ApiService";
import CustomPagination from "../util/CustomPagination";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from 'date-fns/locale';
import Swal from "sweetalert2";
import MapContainer from "./map";
import AuthService from "../util/AuthService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {Tag} from "antd";
import {HelmetProvider} from "react-helmet-async";
import "./assets/css/searchDuty.css";
import Switch from "react-switch";
import StatesSelect from "../util/StatesSelect";
import Footer from "../../../Layouts/Footer";

const SearchDutyMap = (props) => {
    document.title = "Plantão Buscar Mapa | Plantão Rápido";
    const location = useLocation();
    const isPublicRoute = location.pathname === '/duty-map';
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [logo, setLogo] = useState(null);
    const [companyName, setCompanyName] = useState("Plantão Rápido");
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const history = useNavigate();
    const [ufs, setUfs] = useState([]);
    const [cities, setCities] = useState([]);
    const [duties, setDuties] = useState([]);
    const [loading, setLoading] = useState(false); // Estado de carregamento
    const [selectedUf, setSelectedUf] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [radius, setRadius] = useState(10);
    const [mapCenter, setMapCenter] = useState({
        lat: -24.9923319,
        lng: 135.2252427,
    });

    const [filters, setFilters] = useState({
        user_id: "",
        hospital: "",
        duty_scale_day_wee_id: "",
        order_month: "",
        department_id: "",
    });

    const [noResults, setNoResults] = useState(false);

    useEffect(() => {
        if (AuthService.isAuthenticated()) {
            setIsAuthenticated(true);
        }

        // Carregar dados do custom domain
        const domain = window.location.hostname;
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            if (cachedImages.logo) {
                setLogo(cachedImages.logo);
            }
            if (cachedImages.title) {
                setCompanyName(cachedImages.title);
            }
        } catch (error) {
            console.error('Erro ao carregar dados customizados:', error);
        }

        return () => document.body.classList.remove("map-page");
    }, []);

    const handleUfChange = (selectedOption) => {
        setSelectedUf(selectedOption);
        setSelectedCity(null);

        if (selectedOption) {
            ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf: selectedOption.value}, false)
                .then((res) => {
                    const data = res.data;
                    if (!data.errors) {
                        setCities(
                            data.map((city) => ({
                                value: city.id,
                                label: city.name,
                                latitude: city.latitude,
                                longitude: city.longitude,
                            }))
                        );
                    }
                })
                .catch((error) => {

                });
        } else {
            setCities([]);
        }
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
    };

    const fetchDuties = (page) => {
        setLoading(true);
        setNoResults(false);


        if(selectedCity &&  selectedCity?.latitude &&  selectedCity?.longitude)
                setMapCenter({
                    lat: selectedCity.latitude,
                    lng: selectedCity.longitude,
                });


        const endpoint = isAuthenticated ? 'duty/duty-record' : 'duty/duty-record-public';

        ApiService.send(
            "post",
            `${process.env.REACT_APP_URL_API}${endpoint}`,
            {
                freeForMe: true,
                idCity: selectedCity?.value,
                page,
            },
            isAuthenticated
        )
            .then((response) => {
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setDuties(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

            })
            .catch((error) => {
                ApiService.handleApiError(error);
            })
            .finally(() => {
                setLoading(false); // Definindo o carregamento como falso após a busca
            });
    };

    const handleRadiusChange = (event) => {
        const newValue = event.target.value;
        setRadius(newValue);
    };

    const calculateDuration = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const duration = intervalToDuration({start: startDate, end: endDate});
        return formatDuration(duration, {format: ["hours", "minutes"], locale: ptBR});
    };

    const handleSearchClick = () => {
            fetchDuties(1);

    };

    const handlePageChange = (page) => {
        fetchDuties(page);
    };

    const handleInterestClick = (dutyId, hasInterest) => {
        const endpoint = hasInterest ? "duty/disable-interest" : "duty/accept";
        const action = hasInterest ? "cancelado" : "registrado";

        ApiService.send(
            hasInterest ? "delete" : "post",
            `${process.env.REACT_APP_URL_API}${endpoint}`,
            {id: dutyId},
            true
        )
            .then((res) => {
                Swal.fire({
                    title: "Sucesso",
                    text: `Manifestação de interesse ${action} com sucesso!`,
                    icon: "success",
                    confirmButtonText: "OK",
                });

                // Atualiza o estado local dos interesses
                setDuties((prevDuties) =>
                    prevDuties.map((duty) =>
                        duty.id === dutyId ? {
                            ...duty,
                            interest_status: !hasInterest,
                            interest: hasInterest ? 0 : 1
                        } : duty
                    )
                );
            })
            .catch((error) => {
                if (error.response) {
                    let messageErro = '';

                    if (error.response.data.errors) {
                        messageErro = error.response.data.errors.join("<br/>")
                    }
                    Swal.fire({
                        title: "Erro",
                        text: `${error.response.data.message} `,
                        html: `${messageErro}`,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                } else {

                }
            });
    };

    const userData = AuthService.getUserData();

    const renderPublicHeader = () => (
        <header id="page-topbar" className="public-header" style={{left: 0}}>
            <div className="container-fluid" style={{paddingLeft: 0}}>
                <div className="navbar-header" style={{paddingLeft: 0}}>
                    <div className="d-flex align-items-center" style={{marginLeft: '15px'}}>
                        <Link to={isAuthenticated ? "/admin" : "/duty-map"}>
                            {logo && <img src={logo} alt="" height="40" />}
                        </Link>
                    </div>

                    <div className="d-flex align-items-center">
                        {isAuthenticated ? (
                            <Dropdown isOpen={userDropdownOpen} toggle={() => setUserDropdownOpen(!userDropdownOpen)} className="ms-sm-3 header-item topbar-user">
                                <DropdownToggle tag="button" type="button" className="btn">
                                    <span className="d-flex align-items-center">
                                        <img
                                            className="rounded-circle header-profile-user"
                                            src={userData?.profile_image || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(userData?.name || 'User')}
                                            alt="Avatar"
                                            style={{width: '32px', height: '32px', objectFit: 'cover'}}
                                        />
                                        <span className="text-start ms-xl-2">
                                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                                {userData?.name?.split(' ')[0] || 'Usuário'}
                                            </span>
                                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                                                {userData?.email || ''}
                                            </span>
                                        </span>
                                        <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <h6 className="dropdown-header">Bem vindo, {userData?.name?.split(' ')[0]}!</h6>
                                    <DropdownItem tag={Link} to="/admin">
                                        <i className="mdi mdi-view-dashboard text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Dashboard</span>
                                    </DropdownItem>
                                    <DropdownItem tag={Link} to="/admin/profile">
                                        <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Meu Perfil</span>
                                    </DropdownItem>
                                    <DropdownItem tag={Link} to="/admin/duty-my">
                                        <i className="mdi mdi-calendar-check text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Meus Plantões</span>
                                    </DropdownItem>
                                    <div className="dropdown-divider"></div>
                                    <DropdownItem tag={Link} to="/logout" className="text-danger">
                                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Sair</span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        ) : (
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/login" className="btn btn-ghost-primary btn-sm">
                                    <i className="ri-login-box-line align-middle me-1"></i> Login
                                </Link>
                                <Link to="/register" className="btn btn-primary btn-sm">
                                    <i className="ri-user-add-line align-middle me-1"></i> Cadastrar
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );

    return (
        <React.Fragment>
            {isPublicRoute && renderPublicHeader()}
            <div className="page-content" style={isPublicRoute ? {marginLeft: 0, paddingTop: '70px'} : {}}>
                <Container fluid>
                    {!isPublicRoute && <BreadCrumb title="Buscar Mapa" pageTitle="Plantão"/>}
                    <Row>
                        <div className="col-lg-8 map-section">
                            <div id="map" className="map-listing">
                                <div style={{height: "100vh", width: "100%"}}>
                                    <MapContainer
                                        places={duties.map((duty) => ({
                                            cityName: duty.hospital.city.name,
                                            uf: duty.hospital.uf,
                                            id: duty.id,
                                            doc_name: duty.hospital.name,
                                            speciality: duty.user.speciality,
                                            address: duty.hospital.address,
                                            date_time: duty.date_time,
                                            date_time_end: duty.date_time_end,
                                            value: duty.value,
                                            lat: parseFloat(duty.hospital.latitude),
                                            lng: parseFloat(duty.hospital.longitude),
                                            icons: "default",
                                            profile_link: "/admin/location-detail/" + duty.hospital.url_page,
                                            total_review: duty.user.total_review,
                                            image: duty.hospital.images[0] ? duty.hospital.images[0].file : "",
                                            interest: duty.interest,
                                            interest_status: duty.interest_status
                                        }))}
                                        center={mapCenter}
                                        googleMapsApiKey="AIzaSyDlQroQt9ajQefSBB5PiwcUNSfD1ZY8oaw"
                                        onInterestClick={handleInterestClick}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 list-section">
                            <div className="search-box">
                                <div className="row align-items-center mb-4">
                                    <div className="col-12 d-flex justify-content-between align-items-center">
                                        <span className="alert alert-info py-1 px-2 d-inline-block mb-0">
                                            {duties.length} Plantões Disponíveis
                                        </span>
                                        <div className="btn-group" role="group">
                                            <Link
                                                to={isPublicRoute ? "/duty-list" : "/admin/duty-search"}
                                                className="btn btn-outline-primary btn-sm"
                                                title="Ver como Lista"
                                            >
                                                <i className="ri-list-unordered"></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm active"
                                                title="Ver como Mapa"
                                            >
                                                <i className="ri-map-pin-line"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div
                                        className="mt-2 col-12 col-sm-12	col-md-12	col-lg-12	col-xl-12 select-container">
                                        <label>Estado</label>
                                        <StatesSelect value={selectedUf} onChange={handleUfChange} />
                                    </div>
                                    <div
                                        className="mt-2 col-12 col-sm-12	col-md-12	col-lg-12	col-xl-12  select-container">
                                        <label>Cidade</label>
                                        <Select
                                            value={selectedCity}
                                            onChange={handleCityChange}
                                            options={cities}
                                            placeholder="Selecione a Cidade"
                                            isDisabled={!selectedUf}
                                            isSearchable
                                            menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999
                                                }), // Definindo z-index alto
                                                menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                            }}
                                        />
                                    </div>
                                    <div className="mb-1">
                                        <label className="me-2">Credenciado:</label><br/>
                                        <Switch
                                            checked={filters.is_credenciamento === 1}
                                            onChange={(checked) => setFilters({
                                                ...filters,
                                                is_credenciamento: checked ? 1 : 0
                                            })}
                                            onColor="#0d6efd"
                                            offColor="#ccc"
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            title="Selecionar automaticamente o primeiro plantonista que se candidatar ao plantão"
                                            className="react-switch me-2"
                                        />
                                        <span>{filters.is_credenciamento === 1 ? "Sim" : "Não"}</span>
                                    </div>

                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary w-100"
                                                onClick={() => handleSearchClick()}>
                                            <i className="fa fa-search"></i> Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {loading ? (
                                    <>
                                        <div
                                            className="col-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 mb-4">
                                            <div className="profile-widget">
                                                <Skeleton height={150}/>
                                                <div className="pro-content">
                                                    <h5 className="title"><Skeleton width={100}/></h5>
                                                    <ul className="available-info mt-2">
                                                        <li><Skeleton width={200}/></li>
                                                        <li><Skeleton width={150}/></li>
                                                        <li><Skeleton width={150}/></li>
                                                        <li><Skeleton width={100}/></li>
                                                        <li><Skeleton width={100}/></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
                                            <div className="profile-widget">
                                                <Skeleton height={150}/>
                                                <div className="pro-content">
                                                    <h5 className="title"><Skeleton width={100}/></h5>
                                                    <ul className="available-info mt-2">
                                                        <li><Skeleton width={200}/></li>
                                                        <li><Skeleton width={150}/></li>
                                                        <li><Skeleton width={150}/></li>
                                                        <li><Skeleton width={100}/></li>
                                                        <li><Skeleton width={100}/></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    duties.length > 0 ? (
                                        duties.map((duty) => (
                                            <div
                                                className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4"
                                                key={duty.id}>
                                                <div
                                                    className="profile-widget d-flex flex-column justify-content-between">
                                                    <div>
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <img
                                                                    src={duty.hospital.images[0].file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                                                    alt={duty.hospital.name}
                                                                    width={100}
                                                                    className="img-fluid rounded"
                                                                />
                                                            </div>
                                                            <div className="col-8">
                                                                <a
                                                                    target="_blank"
                                                                    style={{textDecoration: 'none', color: 'inherit'}}
                                                                    href={`/admin/location-detail/${duty.hospital.url_page}`}>
                                                                    <strong className="title"
                                                                            style={{fontSize: '14px'}}>
                                                                        {duty.hospital.name}
                                                                    </strong>
                                                                </a>
                                                                <div className="available-info">
                                                                    <i className="fa fa-map-marker-alt"></i> {duty.hospital.city.name}, {duty.hospital.uf}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="pro-content">


                                                            <ul className="available-info mt-2">

                                                                <li>
                                                                    <i className="far fa-calendar"></i> {new Date(duty.date_time).toLocaleDateString("pt-BR")}{" "}
                                                                    {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </li>
                                                                <li>
                                                                    <i className="far fa-calendar"></i> {new Date(duty.date_time_end).toLocaleDateString("pt-BR")}{" "}
                                                                    {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </li>
                                                                <li>
                                                                    <i className="far fa-clock"></i> {calculateDuration(duty.date_time, duty.date_time_end)}
                                                                </li>
                                                                <li>
                                                                    <i className="far fa-money-bill-alt"></i> R$ {duty.value}{" "}
                                                                </li>
                                                                {duty.observation ? (
                                                                    <li>
                                                                        <i className="far fa-file-alt"></i>
                                                                        {duty.observation.length > 100 ? `${duty.observation.substring(0, 100)}...` : duty.observation}
                                                                    </li>
                                                                ) : ''}
                                                            </ul>
                                                            <div className="specialties-tags mt-2">
                                                                {duty.specialties.map((specialty) => (
                                                                    <Tag color="blue"
                                                                         key={specialty.id}>{specialty.name}</Tag>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row row-sm align-items-end">
                                                        <div
                                                            className="col-12 d-flex justify-content-end align-items-end">
                                                            {!isAuthenticated ? (
                                                                <Link to="/login" className="btn btn-sm btn-primary btn-block">
                                                                    <i className="fa fa-sign-in-alt"></i> Login para candidatar
                                                                </Link>
                                                            ) : duty.interest_status && duty.interest === 1 ? (
                                                                    <button type="button"
                                                                        className="btn btn-sm btn-danger btn-block"
                                                                        onClick={() => handleInterestClick(duty.id, true)}
                                                                    >
                                                                        <i className="fa fa-minus"></i> Cancelar
                                                                        Interesse
                                                                    </button>
                                                                ) : duty.accept_user == null ? (
                                                                    <button type="button"
                                                                        className="btn btn-sm btn-info btn-block btn-interest"
                                                                        onClick={() => handleInterestClick(duty.id, false)}
                                                                    >
                                                                        <i className="fa fa-plus"></i> Interesse
                                                                    </button>
                                                                ) : null}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="alert alert-primary" role="alert">Não foram
                                            encontrados plantões
                                            disponíveis.
                                        </div>
                                    )
                                )}
                            </div>
                            <div className="load-more text-center">
                                <CustomPagination pagination={pagination}
                                                  onChange={handlePageChange}/>
                            </div>
                        </div>

                    </Row>
                </Container>
            </div>
            {isPublicRoute && <Footer />}
        </React.Fragment>
    );
};

export default SearchDutyMap;
